"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeaderRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SortableHeaderCell = _interopRequireDefault(require("./SortableHeaderCell"));

var _excluded = ["columns"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderRow = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var columns = _ref.columns,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: props.headerClassName
  }, columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement(_SortableHeaderCell["default"], _extends({}, props, {
      column: column,
      disabled: props.disableReorder || column.props.disableReorder,
      key: "header-".concat(index),
      index: index
    })) // eslint-disable-line
    ;
  }));
});

exports.HeaderRow = HeaderRow;
HeaderRow.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,
  onColumnResize: _propTypes["default"].func,
  headerClassName: _propTypes["default"].string,
  disableReorder: _propTypes["default"].bool
};

var noop = function noop() {};

HeaderRow.defaultProps = {
  onColumnResize: noop,
  headerClassName: 'table-header',
  disableReorder: false
};

var _default = new _reactSortableHoc.SortableContainer(function (props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderRow, props);
});

exports["default"] = _default;